import React from "react";
import abimg2 from "../../images/sign.png";

import "./style.css";

const Project1 = (props) => {
  return (
    <div className="about-style-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-sm-12 col-12">
            <div className="about-img">
              <img src={props.AbImg} alt="" />
            </div>
          </div>
          <div className="col-lg-8 col-sm-12 col-12">
            <div
              className="about-content"
              dir="rtl"
              style={{ textAlign: "right" }}
            >
              <div className="section-title">
                <h2 className="features-luxury__heading">
                  جذور ترعى… معهد الإعاقة الذهنية في قدسيا
                </h2>
              </div>
              <p style={{ fontSize: "18px" }}>
                على أطراف دمشق، يقف معهد الإعاقة الذهنية في قدسيا شاهدًا على
                حكايات قاسية لأطفال وشباب وُلدوا بإعاقات ذهنية أو حركية، ثم
                تُركوا دون عائلة أو سند. ثلاثون فردًا مجهولو النسب يعيشون اليوم
                داخل المعهد، بلا ذاكرة عائلية، وبلا جذور، لكنهم ليسوا بلا قيمة.
                <br />
                <br />
                يوفّر المعهد، بالشراكة مع وزارة الشؤون الاجتماعية ،تشرف جمعية
                جذور، رعاية يومية لهؤلاء الأفراد في ظل إمكانيات محدودة وموارد
                شحيحة. طعام بسيط، ملابس متبرع بها، وأدوية قد تتأخر أو تنفد، لكن
                ما لا ينفد أبدًا هو الالتزام بكرامتهم وحقهم في حياة آمنة
                وإنسانية.
                <br />
                <br />
                تتولى جمعية جذور مسؤولية حمايتهم، منحهم أسماء وهوية، وتأمين بيئة
                تحاول قدر الإمكان أن تكون بديلًا عن العائلة التي حُرموا منها.
                المعهد ليس مكان إيواء فقط، بل مساحة رعاية واحتواء، تُبذل فيها
                جهود يومية لتخفيف الألم ومنح الاستقرار.
                <br />
                <br />
                ولأن الاستمرارية تحتاج إلى حلول مبتكرة، جاء مشروع سوسيت كمصدر
                دعم أساسي للمعهد. فجميع عائدات المطعم غير الربحي تُخصّص لتأمين
                احتياجات المعهد، من دواء وغذاء ودفء، وتحويل كل فنجان قهوة إلى
                فعل رعاية حقيقي.
                <br />
                <br />
                في معهد قدسيا، لا نغيّر الماضي…لكننا نعمل كل يوم لنمنح الحاضر
                كرامة، وللمستقبل فرصة أكثر رحمة.{" "}
              </p>

              <div className="signature">
                <img style={{ width: "150px" }} src={abimg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project1;
